var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationPush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile-user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 16.667V3.33366C15 2.41316 14.2538 1.66699 13.3333 1.66699H6.66667C5.74617 1.66699 5 2.41316 5 3.33366V16.667C5 17.5875 5.74617 18.3337 6.66667 18.3337H13.3333C14.2538 18.3337 15 17.5875 15 16.667ZM10 6.66699C10.9205 6.66699 11.6667 7.41316 11.6667 8.33366C11.6667 9.25416 10.9205 10.0003 10 10.0003C9.0795 10.0003 8.33333 9.25416 8.33333 8.33366C8.33333 7.41316 9.0795 6.66699 10 6.66699ZM12.013 13.3337H7.98692C7.71642 13.3337 7.49783 13.0742 7.58158 12.8171C7.799 12.1495 8.4265 11.667 9.16658 11.667H10.8332C11.5734 11.667 12.2008 12.1494 12.4183 12.8171C12.502 13.0742 12.2835 13.3337 12.013 13.3337Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationPush);
export default __webpack_public_path__ + "static/media/notificationPush.42de6785a49088936f8fc2b9103da7c8.svg";
export { ForwardRef as ReactComponent };